import { useState, useEffect, useRef, useCallback } from "react";

export default function useAnimatedCounter(targets, options = {}) {
  const { threshold = 0.2, steps = 26, interval = 55 } = options;
  const [counts, setCounts] = useState({
    gap: 0,
    breach: 0,
    growth: 0,
    days: 0,
  });
  const [counted, setCounted] = useState(false);
  const ref = useRef(null);

  const runCount = useCallback(() => {
    let i = 0;
    const iv = setInterval(() => {
      i++;
      const p = Math.min(1, i / steps);
      const e = 1 - Math.pow(1 - p, 3);
      setCounts({
        gap: targets.gap * e,
        breach: targets.breach * e,
        growth: targets.growth * e,
        days: targets.days * e,
      });
      if (p >= 1) clearInterval(iv);
    }, interval);
  }, [targets, steps, interval]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !counted) {
            setCounted(true);
            runCount();
          }
        });
      },
      { threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [counted, runCount, threshold]);

  return { counts, counted, ref };
}
